import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaDownload } from 'react-icons/fa';
import '../styles/ImageGenerator.css';

function ImageGenerator() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [text, setText] = useState('');
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    // بررسی وجود توکن
    setIsLoggedIn(!!token);
  }, []);

  const generateImage = async () => {
    if (!text.trim()) return;

    setLoading(true);
    setImageUrl(null);

    try {
      const token = localStorage.getItem("userToken");
      // 🟢 درخواست به API برای دریافت تصویر (نمونه)
      const response = await fetch(`${API_BASE_URL}/AI/generateimage`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ارسال توکن برای احراز هویت
        },
        body: JSON.stringify({ text: text }),
      });

      const data = await response.json();
      if (!data.response || data.response == undefined )
        if (data.error != undefined )
          alert(`Error: ${data.error}`); // نمایش پیام خطا به کاربر
      setImageUrl(data.imageUrl); // 🔹 دریافت لینک تصویر از API
    } catch (error) {
      console.error('Error receiving image:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadImage = async () => {
    if (!imageUrl) return;
  
    try {
      const response = await fetch(`${API_BASE_URL}/AI/fetch-image?imageUrl=${encodeURIComponent(imageUrl)}`);
      if (!response.ok) throw new Error(`Failed to fetch the image. Status: ${response.status}`);
  
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'generated-image.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
      console.error("Error downloading image:", error.message);
  }
  
  };

  if (!isLoggedIn) {
      return (
        <motion.div
          className="chat-page"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
        >
          <h2>Please Login First</h2>
        </motion.div>
      );
    }
  return (
    <motion.div
      className="image-generator-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <h1>Summon Image with Legion</h1>

      <div className="image-container">
        {loading && <p>Generating image...</p>}
        {imageUrl && (
          <>
            <img src={imageUrl} alt="AI Generated" className="generated-image" />
            <p className="warning-text">📌 Save this image now, it won't be accessible later!</p>
            <button  onClick={downloadImage} className="download-btn">
              <FaDownload /> Download image
            </button>
          </>
        )}
      </div>

      <div className="input-container">
        <input
          type="text"
          placeholder="Enter your description for the image..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button onClick={generateImage} className="send-btn">
          <FaArrowRight />
        </button>
      </div>
    </motion.div>
  );
}

export default ImageGenerator;
